import cn from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';

import { SecondaryLink } from '@bibliocommons/base-links';

import './TagList.scss';

export default class TagList extends React.PureComponent {
  handleClick(tag) {
    const { metadataId, trackCatalogExplore } = this.props;

    const tagName = tag.get('tag');

    const metadata = {
      metadata_category_type: 'community_explore_tag',
      metadata_value: tagName
    };

    const ui = {
      ui_component_label: tagName,
      ui_component_type: 'link-text'
    };

    trackCatalogExplore({ bibId: metadataId, metadata, ui });
  }

  renderTag(tag) {
    const { tagType: TagType } = this.props;

    const tagName = tag.get('tag');
    const searchQuery = `/v2/search?origin=core-catalog-explore&query=${tagName}&searchType=tag`;
    const tagCount = tag.get('count');

    return (
      <li key={`${tagName}-${tagCount}`} className="tag-item">
        <TagType
          className="tag-item-link"
          dataKey="tag-item-link"
          href={searchQuery}
          rel="noopener noreferrer"
          handleClick={() => this.handleClick(tag)}
        >
          {tagName} ({tagCount})
        </TagType>
      </li>
    );
  }

  render() {
    return (
      <ul
        className={cn('cp-tag-list', {
          'tag-list--stacked': this.props.stacked
        })}
      >
        {this.props.tags.map(tag => this.renderTag(tag))}
      </ul>
    );
  }
}

TagList.propTypes = {
  metadataId: PropTypes.string.isRequired,
  stacked: PropTypes.bool,
  tags: ImmutablePropTypes.list.isRequired,
  tagType: PropTypes.func,
  trackCatalogExplore: PropTypes.func.isRequired
};

TagList.defaultProps = {
  tagType: SecondaryLink
};
